
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M63.625 60.25c.25.25.375.625.375 1 0 .5-.125.875-.375 1.125l-1.25 1.125c-.375.375-.75.5-1.125.5-.5 0-.75-.125-1-.5L44.125 47.375c-.375-.25-.5-.5-.5-1v-1.25C41.25 47.375 38.5 49 35.5 50.25S29.25 52 26 52c-4.75 0-9.125-1.125-13.125-3.5-4-2.25-7.125-5.375-9.375-9.375C1.125 35.125 0 30.75 0 26s1.125-9 3.5-13c2.25-4 5.375-7.125 9.375-9.5C16.875 1.25 21.25 0 26 0s9 1.25 13 3.5c4 2.375 7.125 5.5 9.5 9.5 2.25 4 3.5 8.25 3.5 13 0 3.375-.625 6.625-1.875 9.625s-2.875 5.75-5 8h1.25c.375 0 .75.25 1.125.5L63.625 60.25zM26 48c4 0 7.625-.875 11-2.875s6-4.625 8-8S48 30 48 26s-1-7.625-3-11-4.625-6-8-8-7-3-11-3-7.75 1-11.125 3-6 4.625-8 8S4 22 4 26s.875 7.75 2.875 11.125 4.625 6 8 8S22 48 26 48z","opacity":".5"}})])
          )
        }
      }
    